var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 12h18m-12 8.005l-8-8 8-8","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowLeftInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
